import { render, staticRenderFns } from "./DesktopAboutPage.vue?vue&type=template&id=14e5b010&scoped=true"
import script from "./DesktopAboutPage.vue?vue&type=script&lang=js"
export * from "./DesktopAboutPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopAboutPage.vue?vue&type=style&index=0&id=14e5b010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e5b010",
  null
  
)

export default component.exports